import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Instagram, Send, Loader2 } from 'lucide-react';
const WEBHOOK_URL = 'https://hook.eu1.make.com/m1b8rv6spnecdlxqitiina5c65ff1dwk';
type Status = 'idle' | 'loading' | 'success' | 'error';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const isSubmitted = status === 'success';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const fields: Record<string, string> = {
        name,
        phone,
        message,
        source: 'na.lilu website',
        submittedAt: new Date().toISOString()
      };
      const url = `${WEBHOOK_URL}?${new URLSearchParams(fields).toString()}`;
      try {
        await fetch(url, {
          method: 'GET',
          mode: 'no-cors',
          keepalive: true
        });
      } catch {
        // Fallback: image request — never blocked by CORS
        await new Promise<void>(resolve => {
          const img = new Image();
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = url;
        });
      }
      setStatus('success');
      setName('');
      setPhone('');
      setMessage('');
      setTimeout(() => setStatus('idle'), 5000);
    } catch {
      setStatus('error');
    }
  };
  return <section id="contact" className="py-24 bg-white" data-id="element-96" data-mp="31769txu0rkln">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97" data-mp="364g5hv804shx">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-98" data-mp="2s4ewttlhwgrw">
          {/* Contact Info */}
          <div className="w-full lg:w-1/2" data-id="element-99" data-mp="2s6rnqw98e1h3">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-100" data-mp="2w71sk5laelud">
              Зв'яжіться з нами
            </h2>
            <p className="text-brand-dark/70 text-lg mb-10" data-id="element-101" data-mp="qdtn4e97q4ll">
              Готові зробити замовлення або маєте запитання щодо розміру? Наша
              команда готова допомогти вам з персоналізованим шопінгом.
            </p>

            <div className="space-y-6" data-id="element-102" data-mp="1ychbfbi3dh2q">
              <a href="tel:+380964797313" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-brand-burgundy transition-colors group" data-id="element-103" data-mp="1ybfvotq4s6eo">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-brand-burgundy transition-colors" data-id="element-104" data-mp="1pddr6476uvmn">
                  <Phone className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-105" data-mp="2hzyhd1bxh1om" />
                </div>
                <div data-id="element-106" data-mp="2d8q9wau5rqe3">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-107" data-mp="2d7x9drlslx4e">
                    Зателефонувати
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-108" data-mp="35psulk05ss9e">
                    +380 96 479 7313
                  </p>
                </div>
              </a>

              <a href="viber://chat?number=%2B380964797313" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-[#7360F2] transition-colors group" data-id="element-109" data-mp="30x9h0n1h1x4l">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-[#7360F2] transition-colors" data-id="element-110" data-mp="3i8wvnj09lkkk">
                  <MessageCircle className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-111" data-mp="3mbtdh7hzdcng" />
                </div>
                <div data-id="element-112" data-mp="32011vk610q">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-113" data-mp="2idt8yvkqgw">
                    Viber
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-114" data-mp="4uaa804ppqey">
                    Найшвидша відповідь
                  </p>
                </div>
              </a>

              <a href="https://t.me/+380964797313" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-[#229ED9] transition-colors group" data-id="element-115" data-mp="dv84vrt9glkv">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-[#229ED9] transition-colors" data-id="element-116" data-mp="160s2isocvyy">
                  <Send className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-117" data-mp="eyqdal0dpwv0" />
                </div>
                <div data-id="element-118" data-mp="3idck2v90bz2r">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-119" data-mp="3ickr7s6sofg6">
                    Telegram
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-120" data-mp="3edkb4hfpbqwv">
                    +380 96 479 7313
                  </p>
                </div>
              </a>

              <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-[#E1306C] transition-colors group" data-id="element-121" data-mp="3nc5yqr015w4i">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-[#E1306C] transition-colors" data-id="element-122" data-mp="2kis444hjt0cp">
                  <Instagram className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-123" data-mp="2pgjxz41r6wjj" />
                </div>
                <div data-id="element-124" data-mp="2ghq4vnnmsoaq">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-125" data-mp="2gj9nhkwrfbfo">
                    Instagram
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-126" data-mp="349x3yukqr9du">
                    @na.lilu
                  </p>
                </div>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-1/2" data-id="element-127" data-mp="2zgua0lc1xxx4">
            <div className="bg-brand-cream p-8 md:p-10 rounded-3xl" data-id="element-128" data-mp="2zfsvu7zqovb6">
              <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-129" data-mp="3n656vrqa785z">
                Надіслати повідомлення
              </h3>

              {isSubmitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="bg-green-50 text-green-800 p-6 rounded-xl text-center border border-green-200" data-id="element-130" data-mp="3rz81822vuln8">
                  <p className="font-medium text-lg mb-2" data-id="element-131" data-mp="3mvuzy91f3yjh">Дякуємо!</p>
                  <p data-id="element-132" data-mp="3ivkq2lai8nzc">
                    Ваше повідомлення надіслано. Ми зв'яжемося з вами найближчим
                    часом.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-133" data-mp="395rehkad48v3">
                  <div data-id="element-134" data-mp="345v9bhpxibdy">
                    <label htmlFor="name" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-135" data-mp="346o9u0yao4nn">
                      Ім'я
                    </label>
                    <input type="text" id="name" required value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all" placeholder="Ваше ім'я" data-id="element-136" data-mp="2v5qgqdpe9hju" />
                  </div>
                  <div data-id="element-137" data-mp="qwu6al4guuid">
                    <label htmlFor="phone" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-138" data-mp="vxqidlyz1myv">
                      Номер телефону
                    </label>
                    <input type="tel" id="phone" required value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all" placeholder="+380 XX XXX XXXX" data-id="element-139" data-mp="15ol5stnyeslw" />
                  </div>
                  <div data-id="element-140" data-mp="3brk0bf2j2ewt">
                    <label htmlFor="message" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-141" data-mp="36r5orn1pwmu1">
                      Повідомлення (Необов'язково)
                    </label>
                    <textarea id="message" rows={4} value={message} onChange={e => setMessage(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all resize-none" placeholder="Мене цікавить..." data-id="element-142" data-mp="3gok6dpzdnhnx"></textarea>
                  </div>
                  {status === 'error' && <p role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3" data-id="element-143" data-mp="rvva4plwst59">
                      Не вдалося надіслати запит. Спробуйте ще раз або
                      зателефонуйте нам.
                    </p>}
                  <button type="submit" disabled={status === 'loading'} className="w-full py-4 bg-brand-burgundy text-white rounded-xl font-medium hover:bg-brand-burgundy/90 transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-144" data-mp="446dix221iii">
                    {status === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" data-id="element-145" data-mp="3hd2m1flilvdn" /> : <Send className="w-4 h-4" data-id="element-146" data-mp="3ldcpollu49pc" />}
                    {status === 'loading' ? 'Надсилаємо…' : 'Надіслати запит'}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}